import urljoin from 'url-join';
import qs from 'qs';
import ky from './kyInstance';

import { BASE_PATH, withAuthorizationHeader } from '..';

export const getMaMeetings = async (type, params = {}) => {
  return ky.get(urljoin(BASE_PATH, 'meetings', 'ma', type), {
    headers: withAuthorizationHeader(),
    searchParams: qs.stringify(params),
  });
};

export const getMaMeetingProxies = async (params = {}) => {
  return ky.get(urljoin(BASE_PATH, 'meetings', 'proxies', 'ma'), {
    headers: withAuthorizationHeader(),
    searchParams: qs.stringify(params),
  });
};

export const getMaMeetingApplicationForm = async (meetingId) => {
  return ky.get(urljoin(BASE_PATH, 'meetings', 'ma', 'application', 'new', String(meetingId)), {
    headers: withAuthorizationHeader(),
  });
};

export const getMaMeetingApplicationsForMeeting = async (meetingId) => {
  return ky.get(urljoin(BASE_PATH, 'meetings', 'ma', 'application', 'meeting', String(meetingId)), {
    headers: withAuthorizationHeader(),
  });
};

export const getMaMeetingApplication = async (id) => {
  return ky.get(urljoin(BASE_PATH, 'meetings', 'ma', 'application', String(id)), {
    headers: withAuthorizationHeader(),
  });
};

export const createMaMeetingApplication = async (params) => {
  return ky.post(urljoin(BASE_PATH, 'meetings', 'ma', 'application', 'create'), {
    headers: withAuthorizationHeader(),
    body: JSON.stringify(params),
  });
};

export const updateMaMeetingApplication = async (id, params) => {
  return ky.post(urljoin(BASE_PATH, 'meetings', 'ma', 'application', String(id), 'edit'), {
    headers: withAuthorizationHeader(),
    body: JSON.stringify(params),
  });
};

export const getIpmaMeetingApplications = async (type, params = {}) => {
  return ky.get(urljoin(BASE_PATH, 'meetings', 'ipma', type), {
    headers: withAuthorizationHeader(),
    searchParams: qs.stringify(params),
  });
};

export const getIpmaMeetingApplication = async (id) => {
  return ky.get(urljoin(BASE_PATH, 'meetings', 'ipma', 'application', String(id)), {
    headers: withAuthorizationHeader(),
  });
};

export const decideIpmaMeetingApplication = async (id, params) => {
  return ky.post(urljoin(BASE_PATH, 'meetings', 'ipma', 'application', String(id), 'decide'), {
    headers: withAuthorizationHeader(),
    body: JSON.stringify(params),
  });
};

export const chairDecideIpmaMeetingApplication = async (id, params) => {
  return ky.post(urljoin(BASE_PATH, 'meetings', 'ipma', 'application', String(id), 'chair'), {
    headers: withAuthorizationHeader(),
    body: JSON.stringify(params),
  });
};

export const getIpmaMeetingOptions = async (type) => {
  return ky.get(urljoin(BASE_PATH, 'meetings', 'ipma', type, 'options'), {
    headers: withAuthorizationHeader(),
  });
};

export const setIpmaMeetingApplicationVerified = async (id, verified) => {
  return ky.post(urljoin(BASE_PATH, 'meetings', 'ipma', 'application', String(id), 'verified'), {
    headers: withAuthorizationHeader(),
    body: JSON.stringify({ verified }),
  });
};

export const getIpmaMeetingAttendance = async () => {
  return ky.get(urljoin(BASE_PATH, 'meetings', 'attendance', 'ipma', 'form'), {
    headers: withAuthorizationHeader(),
  });
};

export const saveIpmaMeetingAttendance = async (params) => {
  return ky.post(urljoin(BASE_PATH, 'meetings', 'attendance', 'ipma', 'save'), {
    headers: withAuthorizationHeader(),
    body: JSON.stringify(params),
  });
};

export const getIpmaMeetingAttendanceApplication = async (id) => {
  return ky.get(urljoin(BASE_PATH, 'meetings', 'attendance', 'ipma', 'application', String(id)), {
    headers: withAuthorizationHeader(),
  });
};

export const exportIpmaMeetingApplications = async (type, params = {}) => {
  return ky.get(urljoin(BASE_PATH, 'meetings', 'ipma', type, 'export'), {
    headers: withAuthorizationHeader(),
    searchParams: qs.stringify(params),
  });
};

export const respondMaMeetingProxy = async (id, approved) => {
  return ky.post(urljoin(BASE_PATH, 'meetings', 'proxies', 'ma', String(id), 'respond'), {
    headers: withAuthorizationHeader(),
    body: JSON.stringify({ approved }),
  });
};

export const getYcMeetings = async (type, params = {}) => {
  return ky.get(urljoin(BASE_PATH, 'meetings', 'yc', type), {
    headers: withAuthorizationHeader(),
    searchParams: qs.stringify(params),
  });
};

export const getYcMeetingApplicationForm = async (meetingId) => {
  return ky.get(urljoin(BASE_PATH, 'meetings', 'yc', 'application', 'new', String(meetingId)), {
    headers: withAuthorizationHeader(),
  });
};

export const getYcMeetingApplication = async (id) => {
  return ky.get(urljoin(BASE_PATH, 'meetings', 'yc', 'application', String(id)), {
    headers: withAuthorizationHeader(),
  });
};

/**
 * The application carries the signed NDA, so it travels as multipart/form-data.
 * The Content Type header is left out on purpose: the browser has to set it
 * together with the boundary of the body.
 */
export const createYcMeetingApplication = async (body) => {
  return ky.post(urljoin(BASE_PATH, 'meetings', 'yc', 'application', 'create'), {
    headers: withAuthorizationHeader(),
    body,
  });
};

export const updateYcMeetingApplication = async (id, body) => {
  return ky.post(urljoin(BASE_PATH, 'meetings', 'yc', 'application', String(id), 'edit'), {
    headers: withAuthorizationHeader(),
    body,
  });
};

export const getYcMeetingNdaTemplate = async (type) => {
  return ky.get(urljoin(BASE_PATH, 'meetings', 'yc', type, 'nda-template'), {
    headers: withAuthorizationHeader(),
  });
};

export const getYcMeetingApplicationDocument = async (id) => {
  return ky.get(urljoin(BASE_PATH, 'meetings', 'yc', 'application', String(id), 'document'), {
    headers: withAuthorizationHeader(),
  });
};

export const getIpmaMeetingApplicationDocument = async (id) => {
  return ky.get(urljoin(BASE_PATH, 'meetings', 'ipma', 'application', String(id), 'document'), {
    headers: withAuthorizationHeader(),
  });
};
